<template>
  <div>HOME</div>
</template>

<script>
export default {};
</script>

<style>
</style>
